import React from 'react';
import Ciudad from '../../components/ciudad/Ciudad';
import Layout from '../../components/layout/Layout';

const CiudadPage = () => {
    return ( <Layout children={<Ciudad />} /> )
}

export default CiudadPage